// src/components/Topbar.jsx
import React from 'react';
import './Topbar.css';
import PropTypes from 'prop-types';

function Topbar({
  eventName,
  organizerName,
  isPublished,
  onPreview,
  onSave,
  onPublish,
  generatePdf,
}) {
  return (
    <div className="topbar">
      <div className="topbar-left">
        <h1 className="topbar-title">Éditeur de Page</h1>
        <div className="event-info">
          <div className="event-info-item">
            <span className="event-info-label">Événement</span>
            <span className="event-info-value">{eventName}</span>
          </div>
          <div className="event-info-item">
            <span className="event-info-label">Organisateur</span>
            <span className="event-info-value">{organizerName}</span>
          </div>
        </div>
      </div>
      <div className="topbar-right">
        <span className={`status-badge ${isPublished ? 'published' : 'draft'}`}>
          {isPublished ? '✓ Publié' : 'Brouillon'}
        </span>
        <button className="topbar-button" onClick={onPreview}>
          👁 Aperçu
        </button>
        <button className="topbar-button" onClick={onSave}>
          💾 Enregistrer
        </button>
        <button className="topbar-button" onClick={generatePdf}>
          📄 Générer PDF
        </button>
        <button className="topbar-button primary" onClick={onPublish}>
          🚀 Publier
        </button>
      </div>
    </div>
  );
}

Topbar.propTypes = {
  eventName: PropTypes.string.isRequired,
  organizerName: PropTypes.string.isRequired,
  isPublished: PropTypes.bool.isRequired,
  onPreview: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  generatePdf: PropTypes.func.isRequired,
};

export default Topbar;
